import { useTranslation } from "react-i18next";
import { FaceCapture } from "./FaceCapture";

// غلاف لعنصر التقاط الوجه في الصفحة الرئيسية (يُخفَّض حجم HomePage).
export const HomeFaceCapture = ({ flow, camera }) => {
  const { t } = useTranslation();
  return (
    <FaceCapture
      open={flow.open}
      phase={flow.phase}
      message={flow.message}
      similarity={flow.similarity}
      actionLabel={t(`check.${flow.action}`)}
      camera={camera}
      readiness={flow.readiness}
      checking={flow.checking}
      geoError={flow.geoError}
      liveness={flow.liveness}
      onLivenessDone={flow.submitLiveness}
      onLivenessError={flow.fail}
      onLivenessRetry={flow.retry}
      onClose={() => flow.setOpen(false)}
      onCapture={() => flow.submit(camera.grabFrames)}
      onQrCode={flow.applyQrCode}
    />
  );
};
